import { JobSimple } from '@borg/types';

class OrganizationJobsRepository extends Repository<JobSimple> {
  override getMany(id: string) {
    return this._getMany({
      url: () => `/organizations/${id}/jobs`,
      cache: 'always',
    });
  }
}

export const organizationJobsRepository = new OrganizationJobsRepository();
